export default "__VITE_ASSET__mGHju8Ke__"